// Comments on a design (Phase 10-1).
//
// Per design subcollection: designs/{designId}/comments/{commentId}.
// commentCount on the parent design is maintained by a Cloud Function
// trigger, not from the client.

import {
  collection, addDoc, deleteDoc, doc, query, orderBy, onSnapshot,
  serverTimestamp, getDoc,
} from 'firebase/firestore';
import { db, auth } from '../firebase.js';

export const COMMENT_MAX_LEN = 500;

export const CommentService = {
  // Live subscription. Calls cb(comments[]) on every change. Returns unsub fn.
  subscribe(designId, cb) {
    if (!designId) return () => {};
    const q = query(
      collection(db, 'designs', designId, 'comments'),
      orderBy('createdAt', 'asc'),
    );
    return onSnapshot(q, (snap) => {
      cb(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    }, (err) => {
      console.warn('comments subscribe error:', err);
      cb([]);
    });
  },

  async addComment(designId, text) {
    const user = auth.currentUser;
    if (!user || user.isAnonymous) throw new Error('AUTH_REQUIRED');
    const trimmed = (text || '').trim().slice(0, COMMENT_MAX_LEN);
    if (!trimmed) throw new Error('TEXT_REQUIRED');
    // Profile 에서 handle / displayName 가져와 댓글 doc 에 같이 저장 (denorm) —
    // displayName 이 빈 값 / default 일 때 UI 가 @handle 로 fallback 가능하게.
    let handle = null;
    let profileDisplayName = null;
    try {
      const profSnap = await getDoc(doc(db, 'profiles', user.uid));
      if (profSnap.exists()) {
        const p = profSnap.data();
        handle = p.handle || null;
        profileDisplayName = p.displayName || null;
      }
    } catch (e) {
      console.warn('comment addComment: profile read failed', e?.message);
    }
    return addDoc(collection(db, 'designs', designId, 'comments'), {
      userId: user.uid,
      // handle 이 primary identity. displayName 은 사용자가 설정했으면 부가
      // 정보로 같이 박지만 UI 는 handle 만 표시.
      displayName: profileDisplayName || user.displayName || '',
      handle: handle || null,
      photoURL: user.photoURL || null,
      text: trimmed,
      createdAt: serverTimestamp(),
    });
  },

  async deleteComment(designId, commentId) {
    return deleteDoc(doc(db, 'designs', designId, 'comments', commentId));
  },
};
